import styled from 'styled-components';

const TicketsListContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
`;

export default TicketsListContainer;
